import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ShieldStar } from "@phosphor-icons/react";
import { LOGO_URL } from "@/data/content";
import { useSEO } from "@/lib/seo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@thecitypair.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useSEO({ title: "Admin Sign-in | TheCityPair", noindex: true });

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome back."); nav("/admin"); }
    else toast.error(r.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#F7F5F0] flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md" data-testid="admin-login-form">
        <div className="mb-10">
          <Link to="/" className="inline-block mb-6">
            <img src={LOGO_URL} alt="TheCityPair" className="h-20 w-auto object-contain -ml-2" />
          </Link>
          <ShieldStar size={32} weight="duotone" className="text-[#C29B62] mb-3" />
          <p className="tcp-overline text-[#C29B62] mb-3">CMS Access</p>
          <h1 className="font-serif text-4xl tracking-tighter">Administrator <em className="italic">sign-in</em></h1>
          <p className="text-sm text-[#A09E9A] mt-3">Authorized personnel only. All activity is logged.</p>
        </div>

        <div className="space-y-5">
          <div>
            <label className="tcp-label tcp-label-dark">Email</label>
            <input type="email" required className="tcp-input-dark" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div>
            <label className="tcp-label tcp-label-dark">Password</label>
            <input type="password" required className="tcp-input-dark" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-gold w-full justify-center text-xs tracking-[0.16em] uppercase" data-testid="login-submit">
            {loading ? "Authenticating..." : "Sign In"}
          </button>
        </div>

        <p className="text-xs text-[#A09E9A] mt-8">← <a href="/" className="hover:text-[#C29B62]">Back to site</a></p>
      </form>
    </div>
  );
}
